export default function () {
  const widgetName = 'mainCards';
  const widgetOpts = mainCardsOpts;

  // let windowSize = $(window).width();
  // let breakpoint = 800;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    link: [''],
    maxItemsVisible: 4,
    itemsPerPanel: 4,
    lazyLoadImages: true,

    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;

      if (widgetCount == 0) {
        $(`.tier-2-container`).remove();
      } else {
        $(`#${widgetName} .card-widget-item`).each(function (x) {
          let dataWidget = data.items[x];
          let hasLink = dataWidget.URL || dataWidget.PurchaseURL ? true : false;
          let moreBtn = dataWidget.URL ? `<a class='button' href='${dataWidget.URL}'>More</a>` : '';
          let buyBtn = dataWidget.PurchaseURL
            ? `<a class='button' href='${dataWidget.PurchaseURL}'>Buy Now</a>`
            : '';

          const cardStructure = `
          <div class="img-background lozad" style="background: url('${dataWidget.ImageWithPath}')no-repeat center/cover;">
          <div class="overlay"></div>
            <div class="card-content">
            <span class="widget-title">${dataWidget.Title}</span>
            ${
              hasLink
                ? `<div class="btn-container">
              ${moreBtn}
              ${buyBtn}
              </div>`
                : ''
            }
            </div>
          </div>
          `;

          $(this).empty();
          $(this).append(cardStructure);

          // if (dataWidget.URL == null) {
          //   $(this).addClass('void-link');
          //   $(this).removeAttr('href');
          // } else {
          //   $(this).removeAttr('target');
          // }
        });
      }
    },
  });
}
